<template>
<div>
    <v-card style="padding:0; margin: 0" flat :class="{
                  mobileStep: $vuetify.breakpoint.xsOnly,
                  'compact-form': $vuetify.breakpoint.smAndUp,
                  xlargeWidth: $vuetify.breakpoint.xl,
                }">
        <v-card-text>
            <v-layout justify-center v-if="appLoading">
                <v-flex>
                    <h3>Loading Networks...</h3>
        <v-progress-circular size="25" color="grey" indeterminate></v-progress-circular>
                </v-flex>
            </v-layout>
            <v-layout wrap v-if="!appLoading" class="my-0 py-0" justify-center>
                <v-flex xs12 sm="12">
                    <h4 style="
                          color: red;
                          fontSize:16px
                        " class="text-xs-center pt-0 mt-0 ml-5">
                        {{ this.$store.state.currentOrg.landingPageMessage }}
                    </h4>
                </v-flex>
                <v-flex xs12 sm="12" class="text-center" justify-center>
                    <h2 :style="{
                            fontSize: '24px'
                        }">
                        FIND YOUR ADDRESS
                    </h2>
                </v-flex>
                <v-flex xs12 sm="6" md="6" style="text-align: center">
                    <v-text-field rounded outlined v-model="searchLocation" id="pac-input" ref="locationSearch" clearable @click:clear="reset" placeholder="Search" append-icon="search"></v-text-field>
                    <v-btn v-if="$vuetify.breakpoint.xs&&address.country" rounded color="primary" @click="showAddressDialog=true">Confirm Address <v-icon>chevron_right</v-icon></v-btn>
                </v-flex>
                <v-flex xs12 sm="12" v-show="!appLoading" style="padding:0;margin:0">
                    <gmap-map ref="mapRef" :center="center" :zoom="zoom" :options="{
                          styles: mapStyle,
                          streetViewControl: false,
                          disableDefaultUI: true,
                          zoomControl: true,
                          mapTypeControl: true
                        }" style="width: 100%; height: 50vh" @click="getAddressData($event)">
                        <div slot="visible" v-if="loading" style="width: 100%; height: 65vh">

                            <v-card color="white" style="
                            borderRadius: 0;
                             opacity: 0.9;
                      bottom: 0;
                      left: 0;
                      top: 0;
                      right: 0;
                      height: 100%
                    ">
                                <v-card-text style="height: 100%; justify-text: center;">
                                    <v-container fill-height>
                                        <v-layout wrap justify-center>
                                            <v-flex xs12 style="text-align: center">
                                                <v-progress-circular color="primary" style="margin: auto;text-align: center" indeterminate></v-progress-circular>
                                            </v-flex>
                                            <v-flex xs12 style="text-align: center">
                                                <h3>Fetching map data</h3>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </div>
                        <!-- Main toolbar -->
                        <div slot="visible">
                            <v-card v-if="!loading" class="ma-1" style="
                      bottom: 0;
                      left: 0%;
                      height: auto;
                      position: absolute;
                      border: 1px solid grey;
                      borderRadius: 20px;
                    " flat>
                                <v-list  v-for="item in networkStatus" :key="item.name">
                                    <v-list-tile>
                                        <v-list-tile-action >
                                            <v-avatar size="12px" :color="item.colour"></v-avatar>
                                            <!-- <v-icon :color="item.colour">stop</v-icon> -->
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{item.name}}</v-list-tile-title>

                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-card>
                        </div>

                        <!-- Location Info Card -->
                        <div slot="visible" v-if="showAddressForm">
                            <v-card class="ma-1" style="
                      top: 0;
                      right: 0%;
                      height: auto;
                      position: absolute;
                      width: 500px;
                      border: 1px solid grey;
                      borderRadius: 20px;
                    " flat>
                                <v-toolbar color="white" flat>
                                    <v-toolbar-title>Confirm Address</v-toolbar-title>
                                </v-toolbar>
                                <v-card-text style="margin-top: 0px; padding-top: 0px; overflow-y: auto; max-height: 45vh" :key="addressKey">
                                    <v-layout wrap justify-center v-if="!editingAddress" style="margin: 0px; padding: 0px">
                                        <v-flex xs12 justify-center style="margin-bottom: 0; padding-bottom: 0">
                                            <v-list style="padding:0; margin:0">
                                                <v-list-tile v-if="polyInfo&&polyInfo.properties" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-avatar size="15px" :color="polyInfo.properties.network.networkStatus == 'Live'?'light-green':polyInfo.properties.network.networkStatus == 'Pending'?'blue':'orange'">

                                                        </v-avatar>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;">
                                                            {{polyInfo.properties.name}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                <v-list-tile v-else-if="polyInfo&&polyInfo.network" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-avatar size="15px" :color="polyInfo.network.networkStatus == 'Live'?'light-green':polyInfo.network.networkStatus == 'Pending'?'blue':'orange'">
                                                        </v-avatar>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;">
                                                            {{polyInfo.network.name}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>

                                                <v-list-tile v-if="matchedUnit" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-avatar size="15px" :color="matchedUnit.equipmentInstalled?'light-green':'blue'">
                                                        </v-avatar>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;" v-if="matchedUnit.equipmentInstalled">
                                                            Fibre Ready
                                                        </v-list-tile-title>
                                                        <v-list-tile-title style="white-space: normal;" v-else>
                                                            Fibre Installation Required
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                <v-list-tile v-if="matchedUnit" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-icon>location_on</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;">
                                                            {{matchedUnit.locationDescription}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                    <v-list-tile-action>
                                                        <v-icon @click="editingAddress = true">edit</v-icon>
                                                    </v-list-tile-action>
                                                </v-list-tile>
                                                <v-list-tile v-if="!matchedUnit&&address" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-icon>location_on</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;">
                                                            {{formattedAddress}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                    <v-list-tile-action>
                                                        <v-icon @click="editingAddress = true">edit</v-icon>
                                                    </v-list-tile-action>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex>
                                        <v-flex xs12 v-if="!matchedUnit&&matchedAddress.length>0" style="padding:5px; margin:1px">
                                            <h4>Similar Locations</h4>
                                            <v-layout wrap style=" overflow-x: auto;flex-wrap: nowrap; padding: 2px; margin: 5px 0px">
                                                <v-flex v-for="location in matchedAddress" :key="location.id" cols="4">
                                                    <v-card hover style="borderRadius: 10px" @click="setLocation(location)">
                                                        <v-card-text>
                                                            <span>{{location.locationDescription}}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-layout wrap justify-center>
                                                <v-flex xs12 style="text-align: center" v-if="polyInfo&&(polyInfo.properties || polyInfo.network)">
                                                          <v-btn rounded style="opacity: 1"  color="primary" class="white--text" @click="choosePackage()">Choose a Package <v-icon right dark>chevron_right</v-icon>
                                                </v-btn>
                                                    </v-flex>
                                              
                                                    <v-flex xs12 style="text-align: center" v-else>
                                                        <span style="fontSize: 16px">It doesn't looks like you're covered yet</span> <br><br>
                                                <v-btn style="opacity: 1" rounded  color="blue" class="white--text" @click="proceedShowOfInterest()">Show Interest <v-icon right dark>chevron_right</v-icon>
                                               
                                                </v-btn>
                                                    </v-flex>
                                            </v-layout>

                                        </v-flex>
                                    </v-layout>
                                    <v-layout wrap justify-center v-if="editingAddress">
                                        <v-flex xs12 v-if="network&&unitList.length>0">
                                            <v-autocomplete rounded outlined append-icon="search" label="Search for unit in Estate" v-model="matchedUnit" :items="unitList" item-text="locationDescription" item-value="id" return-object></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12  v-if="network&&unitList.length>0" style="text-align: center; padding-top: 0; margin-top: 0">
                                            <v-btn flat color="blue" @click="showAddressDetail=true">Can't find your unit?</v-btn>
                                        </v-flex>
                                        <v-flex xs12 v-if="showAddressDetail" style="width: 100%">
                                            <v-layout wrap justify-center>
 <v-flex xs12 sm="12" lg="4" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0;">
                                            <v-text-field dense style="fontSize: 14px" label="Unit No." v-model="address.unitNumber"> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm="12" lg="4" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Floor No." v-model="address.floorNo"> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm="12" lg="4" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Street No." v-model="address.streetNumber"> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm="12" md="6" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Business / Building Name" v-model="address.building"> </v-text-field>

                                            <!-- <v-text-field label="Province" v-model="address.province"> </v-text-field>
                                      <v-text-field label="Country" v-model="address.country"> </v-text-field>
                                      <v-text-field label="Postal Code" v-model="address.postalCode"> </v-text-field> -->
                                        </v-flex>
                                        <v-flex xs12 sm="12" md="6" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Street Name" v-model="address.streetName"> </v-text-field>

                                        </v-flex>
                                        <v-flex xs12 sm="12" md="6" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Suburb" v-model="address.suburb"> </v-text-field>

                                        </v-flex>
                                        <v-flex xs12 sm="12" md="6" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Postal Code" v-model="address.postalCode"> </v-text-field>

                                        </v-flex>
                                        <v-flex cols="6">
                                            <span style="fontSize: 14px">{{address.province}}</span>
                                        </v-flex>
                                        <v-flex cols="6">
                                            <span style="fontSize: 14px">{{address.country}}</span>

                                        </v-flex>
                                            </v-layout>
                                        </v-flex>
                                       

                                        <v-flex cols="4" justify-center>
                                            <v-btn rounded 
                                            v-if="(network&&unitList.length>0)||(network&&unitList.length>0&&showAddressDetail&&(!address.unitNumber&&!address.streetNumber))"
                                            :disabled="!showAddressDetail?!matchedUnit:!matchedUnit&&!address.unitNumber&&!address.streetNumber"
                                            color="primary" class="white--text" @click="editingAddress=false">Done <v-icon>chevron_right</v-icon>
                                            </v-btn>
                                             <v-btn rounded 
                                            v-else
                                            :disabled="!address.unitNumber&&!address.streetNumber"
                                            color="primary" class="white--text" @click="editingAddress=false">Done <v-icon>chevron_right</v-icon>
                                            </v-btn>

                                        </v-flex>

                                        <!-- <v-flex xs12 sm="12" style="padding-top:0; margin-top:0">
                                      <v-text-field label="Street Name"> </v-text-field>
                                  </v-flex> -->
                                        <!-- <v-flex xs12 sm="12" lg="6">
                                      <v-text-field label="Apt Number"> </v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm="12" lg="6">
                                      <v-text-field label="Apt Number"> </v-text-field>
                                  </v-flex> -->
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </div>

                        <gmap-marker v-if="locationMarker && locationMarker.lat != null && mapLoaded" :animation="0" :draggable="true" :position="locationMarker" @dragend="getAddressData($event)" @click="SelectLocationMarker()" :key="key"></gmap-marker>

                    </gmap-map>
                </v-flex>
            </v-layout>
        </v-card-text>
        <!-- <v-container
                  :class="{
                    mobileStep: $vuetify.breakpoint.xsOnly,
                    largeWidth: $vuetify.breakpoint.smAndUp,
                  }"
                  style="
                    text-align: center;
                    padding-bottom: 0;
                    margin-bottom: 0;
                  "
                >
                  
             </v-container> -->
    </v-card>

    <v-dialog v-model="showAddressDialog" fullscreen>
        <v-card flat>
            <v-toolbar color="white" flat>
                <v-toolbar-title>Address Information</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn text @click="showAddressDialog=false">X</v-btn>
            </v-toolbar>
             <v-card-text style="margin-top: 0px; padding-top: 0px;" :key="addressKey">
                                    <v-layout wrap justify-center v-if="!editingAddress" style="margin: 0px; padding: 0px">
                                        <v-flex xs12 justify-center style="margin-bottom: 0; padding-bottom: 0">
                                            <v-list style="padding:0; margin:0">
                                                <v-list-tile v-if="polyInfo&&polyInfo.properties" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-avatar size="15px" :color="polyInfo.properties.network.networkStatus == 'Live'?'light-green':polyInfo.properties.network.networkStatus == 'Pending'?'blue':'orange'">

                                                        </v-avatar>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;">
                                                            {{polyInfo.properties.name}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                <v-list-tile v-else-if="polyInfo&&polyInfo.network" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-avatar size="15px" :color="polyInfo.network.networkStatus == 'Live'?'light-green':polyInfo.network.networkStatus == 'Pending'?'blue':'orange'">
                                                        </v-avatar>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;">
                                                            {{polyInfo.network.name}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>

                                                <v-list-tile v-if="matchedUnit" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-avatar size="15px" :color="matchedUnit.equipmentInstalled?'light-green':'blue'">
                                                        </v-avatar>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;" v-if="matchedUnit.equipmentInstalled">
                                                            Fibre Ready
                                                        </v-list-tile-title>
                                                        <v-list-tile-title style="white-space: normal;" v-else>
                                                            Fibre Installation Required
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                <v-list-tile v-if="matchedUnit" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-icon>location_on</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;">
                                                            {{matchedUnit.locationDescription}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                    <v-list-tile-action>
                                                        <v-icon @click="editingAddress = true">edit</v-icon>
                                                    </v-list-tile-action>
                                                </v-list-tile>
                                                <v-list-tile v-if="!matchedUnit&&address" style="margin: 0px; padding: 0px">
                                                    <v-list-tile-action>
                                                        <v-icon>location_on</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title style="white-space: normal;">
                                                            {{formattedAddress}}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                    <v-list-tile-action>
                                                        <v-icon @click="editingAddress = true">edit</v-icon>
                                                    </v-list-tile-action>
                                                </v-list-tile>
                                            </v-list>
                                        </v-flex>
                                        <v-flex xs12 v-if="!matchedUnit&&matchedAddress.length>0" style="padding:5px; margin:1px">
                                            <h4>Similar Locations</h4>
                                            <v-layout wrap style=" overflow-x: auto;flex-wrap: nowrap; padding: 2px; margin: 5px 0px">
                                                <v-flex v-for="location in matchedAddress" :key="location.id" cols="4">
                                                    <v-card hover style="borderRadius: 10px" @click="setLocation(location)">
                                                        <v-card-text>
                                                            <span>{{location.locationDescription}}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-layout wrap justify-center>
                                                 <v-flex xs12 style="text-align: center" v-if="polyInfo&&(polyInfo.properties || polyInfo.network)">
                                                          <v-btn rounded style="opacity: 1"  color="primary" class="white--text" @click="choosePackage()">Choose a Package <v-icon right dark>chevron_right</v-icon>
                                                </v-btn>
                                                    </v-flex>
                                              
                                                    <v-flex xs12 style="text-align: center" v-else>
                                                        <span style="fontSize: 16px">It doesn't looks like you're covered yet</span> <br><br>
                                                <v-btn style="opacity: 1" rounded  color="blue" class="white--text" @click="proceedShowOfInterest()">Show Interest <v-icon right dark>chevron_right</v-icon>
                                               
                                                </v-btn>
                                                    </v-flex>
                                            </v-layout>

                                        </v-flex>
                                    </v-layout>
                                    <v-layout wrap justify-center v-if="editingAddress">
                                        <v-flex xs12 v-if="network&&unitList.length>0">
                                            <v-autocomplete rounded outlined append-icon="search" label="Search for unit in Estate" v-model="matchedUnit" :items="unitList" item-text="locationDescription" item-value="id" return-object></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12  v-if="network&&unitList.length>0" style="text-align: center; padding-top: 0; margin-top: 0">
                                            <v-btn flat color="blue" @click="showAddressDetail=true">Can't find your unit?</v-btn>
                                        </v-flex>
                                        <v-flex xs12 v-if="showAddressDetail" style="width: 100%">
                                            <v-layout wrap justify-center>
 <v-flex xs12 sm="12" lg="4" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0;">
                                            <v-text-field dense style="fontSize: 14px" label="Unit No." v-model="address.unitNumber"> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm="12" lg="4" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Floor No." v-model="address.floorNo"> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm="12" lg="4" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Street No." v-model="address.streetNumber"> </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm="12" md="6" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Business / Building Name" v-model="address.building"> </v-text-field>

                                            <!-- <v-text-field label="Province" v-model="address.province"> </v-text-field>
                                      <v-text-field label="Country" v-model="address.country"> </v-text-field>
                                      <v-text-field label="Postal Code" v-model="address.postalCode"> </v-text-field> -->
                                        </v-flex>
                                        <v-flex xs12 sm="12" md="6" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Street Name" v-model="address.streetName"> </v-text-field>

                                        </v-flex>
                                        <v-flex xs12 sm="12" md="6" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Suburb" v-model="address.suburb"> </v-text-field>

                                        </v-flex>
                                        <v-flex xs12 sm="12" md="6" style="padding-top:0; margin-top:0, padding-bottom:0; margin-bottom:0">
                                            <v-text-field dense style="fontSize: 14px" label="Postal Code" v-model="address.postalCode"> </v-text-field>

                                        </v-flex>
                                        <v-flex cols="6">
                                            <span style="fontSize: 14px">{{address.province}}</span>
                                        </v-flex>
                                        <v-flex cols="6">
                                            <span style="fontSize: 14px">{{address.country}}</span>

                                        </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex cols="4" justify-center>
                                            <v-btn rounded 
                                            v-if="(network&&unitList.length>0)||(network&&unitList.length>0&&showAddressDetail&&(!address.unitNumber&&!address.streetNumber))"
                                            :disabled="!showAddressDetail?!matchedUnit:!matchedUnit&&!address.unitNumber&&!address.streetNumber"
                                            color="primary" class="white--text" @click="editingAddress=false">Done <v-icon>chevron_right</v-icon>
                                            </v-btn>
                                             <v-btn rounded 
                                            v-else
                                            :disabled="!address.unitNumber&&!address.streetNumber"
                                            color="primary" class="white--text" @click="editingAddress=false">Done <v-icon>chevron_right</v-icon>
                                            </v-btn>

                                        </v-flex>

                                        <!-- <v-flex xs12 sm="12" style="padding-top:0; margin-top:0">
                                      <v-text-field label="Street Name"> </v-text-field>
                                  </v-flex> -->
                                        <!-- <v-flex xs12 sm="12" lg="6">
                                      <v-text-field label="Apt Number"> </v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm="12" lg="6">
                                      <v-text-field label="Apt Number"> </v-text-field>
                                  </v-flex> -->
                                    </v-layout>
                                </v-card-text>
           
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api.js";
import GeoJsonGeometriesLookup from "geojson-geometries-lookup";
import {
    gmapApi
} from "vue2-google-maps";
export default {
    props: ['location', 'networkOperator'],
    data() {
        return {
            addressKey: 0,
            address: {
                unitNumber: null,
                floorNo: null,
                building: null,
                streetNumber: null,
                streetName: null,
                suburb: null,
                province: null,
                country: null,
                postalCode: null,
            },
            defaultAddress: {
                unitNumber: null,
                floorNo: null,
                building: null,
                streetNumber: null,
                streetName: null,
                suburb: null,
                province: null,
                country: null,
                postalCode: null,
            },
            appLoading: false,
            loading: true,
            center: {
                lat: -33.919473,
                lng: 18.427059
            },
            editingAddress: false,
            estateList: [],
            geoData: {},
            glookup: null,
            key: 0,
            locationMarker: {},
            map: null,
            mapLoaded: false,
            mapStyle: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#f5f5f5",
                    }, ],
                },
                {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off",
                    }, ],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161",
                    }, ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#f5f5f5",
                    }, ],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry",
                    stylers: [{
                        visibility: "off",
                    }, ],
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd",
                    }, ],
                },
                {
                    featureType: "poi",
                    stylers: [{
                        visibility: "off",
                    }, ],
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee",
                    }, ],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575",
                    }, ],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5",
                    }, ],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e",
                    }, ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff",
                    }, ],
                },
                {
                    featureType: "road",
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off",
                    }, ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575",
                    }, ],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dadada",
                    }, ],
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161",
                    }, ],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e",
                    }, ],
                },
                {
                    featureType: "transit",
                    stylers: [{
                        visibility: "off",
                    }, ],
                },
                {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5",
                    }, ],
                },
                {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee",
                    }, ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#c9c9c9",
                    }, ],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e",
                    }, ],
                },
            ],
            networkStatus: [{
                    name: "Live",
                    colour: "green"
                },
                {
                    name: "Under Construction",
                    colour: "blue"
                },
                {
                    name: "Planned",
                    colour: "orange"
                },
            ],
            matchedUnit: null,
            matchedAddress: [],
            network: null,
            polyInfo: {},
            selectedNetwork: null,
            searchLocation: '',
            showAddressDialog: false,
            showAddressForm: false,
            showAddressDetail: false,
            unitList: [],
            zoom: 15
        }
    },
    created() {
        this.fetchEstates()
        this.geolocate()
    },
    mounted() {
        // this.plotMap();
    },
    watch: {
        matchedUnit(value){
            this.setAddress()
        },
        selectedNetwork(value) {
            if (value) {
                this.unitList = []
                this.fetchUnits(value)
                this.network = this.estateList.find(x => x.id == value)
                this.showAddressDetail = false
            } else {
                this.network = null
                this.unitList = []
                this.showAddressDetail = true

            }
        },
        'address.streetNumber': {
            immediate: true,
            handler(value) {
                
                if (value &&!this.address.fullUnitDetails) {
                    this.matchedUnit = null
                    let find = this.unitList.filter(x => x.locationDescription.includes(this.address.streetName))
                    this.matchedAddress = find
                    if (find)
                        if (this.address.streetNumber) {
                            let exactMatch = find.find(x => x.unitNo == this.address.streetNumber)
                            if (exactMatch) {
                                this.matchedUnit = exactMatch
                                if (this.matchedUnit) {
                                    this.address.id = this.matchedUnit.id
                                    this.address.fullUnitDetails = this.matchedUnit
                                    this.address.locationDescription = this.matchedUnit.locationDescription
                                }
                            }
                        }
                }
            }
        },
        'address.streetName': {
            immediate: true,
            handler(value) {
                if (value&&!this.address.fullUnitDetails) {
                this.matchedUnit = null

                    let find = this.unitList.filter(x => x.locationDescription.includes(this.address.streetName))
                    this.matchedAddress = find
                    if (find)
                        if (this.address.streetNumber) {
                            let exactMatch = find.find(x => x.unitNo == this.address.streetNumber)
                            if (exactMatch) {
                                this.matchedUnit = exactMatch
                                if (this.matchedUnit) {
                                    this.address.id = this.matchedUnit.id
                                    this.address.fullUnitDetails = this.matchedUnit
                                    this.address.locationDescription = this.matchedUnit.locationDescription
                                }
                            }
                        }
                }
            }
        }
    },
    computed: {
        google: gmapApi,
        formattedAddress() {
            let address = ''
            if (this.address.unitNumber) {
                address += 'Unit ' + this.address.unitNumber + ', '
            }
            if (this.address.floorNo) {
                address += 'floor ' + this.address.floorNo + ', '
            }
            if (this.address.building) {
                address += this.address.building + ', '
            }
            if (this.address.streetNumber) {
                address += this.address.streetNumber + ' '
            }
            if (this.address.streetName) {
                address += this.address.streetName + ', '
            }
            if (this.address.suburb) {
                address += this.address.suburb + ', '
            }
            if (this.address.town) {
                address += this.address.town + ', '
            }
            if (this.address.province) {
                address += this.address.province + ', '
            }
            if (this.address.country) {
                address += this.address.country + '  '
            }
            if (this.address.postalCode) {
                address += this.address.postalCode
            }
            return address
        }
    },
    methods: {
        choosePackage() {
            // console.log(this.address)
            this.$emit('choosePackage', this.network, this.address)
        },
        proceedShowOfInterest() {
            this.$emit('showOfInterest', this.address)
        },
        fetchEstates() {
            this.appLoading = true;
            this.loadingText = " \n\nFetching Available Networks...";
            Api()
          .get("/ftthApplication/isp/activelocationnetworks/" + this.networkOperator.id)
                .then(async (response) => {
                    this.estateList = response.data;
                    //   this.estateList.unshift("My area is not in the list");
                    let geoObj = {
                        type: "FeatureCollection",
                        name: "Network Polygons",
                        crs: {
                            type: "name",
                            properties: {
                                name: "urn:ogc:def:crs:OGC:1.3:CRS84"
                            },
                        },
                        features: [],
                    };
                    let objects = response.data;
                    for (let x = 0; x < objects.length; x++) {
                        let obj = {
                            type: "Feature",
                            properties: {
                                name: objects[x].name,
                                fno: objects[x].organisation,
                                network: objects[x],
                                tessellate: 1,
                            },
                            geometry: {
                                type: "Polygon",
                                coordinates: objects[x].networkPolygons.length > 0 ?
                                    JSON.parse(objects[x].networkPolygons[objects[x].networkPolygons.length - 1].coordinates) : [],
                            },
                        };
                        if (obj.geometry.coordinates.length > 0) {
                            if (
                                obj.geometry.coordinates[0][0][0] !==
                                obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][0] ||
                                obj.geometry.coordinates[0][0][1] !==
                                obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][1]
                            ) {
                                obj.geometry.coordinates[0].push(obj.geometry.coordinates[0][0]);
                            }
                            geoObj.features.push(obj);
                        }
                    }
                    this.geoData = geoObj;
                    this.glookup = new GeoJsonGeometriesLookup(this.geoData);

                    this.appLoading = false;
                    //   this.plotMap();
                    setTimeout(() => {
                        this.plotMap();
                    }, 300);
                });
        },
        async fetchUnits(locationNetworkId) {
            this.matchedUnit = null
            this.matchedAddress = []
            await Api().get('/ftthApplication/activeUnits/isp/' + locationNetworkId).then(res => {
                this.unitList = res.data
                let find = this.unitList.filter(x => x.locationDescription.includes(this.address.streetName))
                this.matchedAddress = find
                if (find)
                    if (this.address.streetNumber) {
                        let exactMatch = find.find(x => x.unitNo == this.address.streetNumber)
                        if (exactMatch) {
                            this.matchedUnit = exactMatch
                            this.address.id = this.matchedUnit.id
                            this.address.fullUnitDetails = this.matchedUnit
                            this.address.locationDescription = this.matchedUnit.locationDescription

                        }
                    }
            })
        },
        getAddressData: async function (addressData, network = {}) {
            //this.confirmAddress = false;
            this.polyInfo = network
            this.selectedNetwork = network.id
            var latlng = new google.maps.LatLng(addressData.latLng.lat(), addressData.latLng.lng());
            //   this.infoWindowPos = {
            //     lat: addressData.latLng.lat(),
            //     lng: addressData.latLng.lng(),
            //   };
            let resultData = null;
            var geocoder = new google.maps.Geocoder();
            await geocoder.geocode({
                    latLng: latlng,
                },
                async function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        results = results.filter(x => x.geometry.location_type == 'GEOMETRIC_CENTER' && x.types.includes('route'))
                        if (results[0]) {
                            resultData = results[0];
                        } else {
                            //   alert("No results found");
                        }
                    } else {
                        // alert("Geocoder failed due to: " + status);
                    }
                }
            );
            this.searchLocation = resultData.formatted_address;
            //   this.center = resultData.geometry.location;
            this.locationMarker = latlng;
            this.address.lat = latlng.lat()
            this.address.lng = latlng.lng()
            this.address.friendlyAddress = this.searchLocation

            this.address = {}
            for (let i = 0; i < resultData.address_components.length; i++) {
                if (resultData.address_components[i].types.includes('street_number')) {
                    this.address.streetNumber = resultData.address_components[i].short_name
                }
                if (resultData.address_components[i].types.includes('route')) {
                    this.address.streetName = resultData.address_components[i].long_name
                }
                if (resultData.address_components[i].types.includes('sublocality')) {
                    this.address.suburb = resultData.address_components[i].long_name
                }
                if (resultData.address_components[i].types.includes('administrative_area_level_2')) {
                    this.address.town = resultData.address_components[i].long_name
                }
                if (resultData.address_components[i].types.includes('administrative_area_level_1')) {
                    this.address.province = resultData.address_components[i].long_name
                }
                if (resultData.address_components[i].types.includes('country')) {
                    this.address.country = resultData.address_components[i].long_name
                }
                if (resultData.address_components[i].types.includes('postal_code')) {
                    this.address.postalCode = resultData.address_components[i].short_name
                }

            }
            const point = {
                type: "Point",
                coordinates: [latlng.lng(), latlng.lat()],
            };
            let testPoly = this.glookup.getContainers(point);
            if (testPoly.features.length > 0) {
                this.polyInfo = testPoly.features[0]
                this.selectedNetwork = this.polyInfo.properties.network.id
            }
            
            if (this.$vuetify.breakpoint.xs) {
                    this.showAddressDialog = true
                    this.editingAddress = true

                } else {
                    this.showAddressForm = true
                    this.editingAddress = true
                }
        },
        geolocate: function () {
            navigator.geolocation.getCurrentPosition((position) => {
                if (position && position.coords) {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                }

            });
        },
        initMapAutoComplete() {
            const input = document.getElementById("pac-input");
            const autocomplete = new this.google.maps.places.Autocomplete(input, {});
            autocomplete.setComponentRestrictions({
                country: ["za"],
            });

            // this.fetchPackages(this.detail.address.estate, "Fibre");
            google.maps.event.addListener(autocomplete, "place_changed", async () => {
                let split = this.searchLocation.split(' ')
                let curPlace = autocomplete.getPlace();
                //   this.$refs.locationSearch.unfocus();
                this.address = this.defaultAddress
                this.searchLocation = curPlace.formatted_address
                this.address.friendlyAddress = this.searchLocation
                for (let i = 0; i < curPlace.address_components.length; i++) {
                    if (curPlace.address_components[i].types.includes('street_number')) {
                        this.address.streetNumber = curPlace.address_components[i].short_name
                    }
                    if (curPlace.address_components[i].types.includes('route')) {
                        this.address.streetName = curPlace.address_components[i].long_name
                    }
                    if (curPlace.address_components[i].types.includes('sublocality')) {
                        this.address.suburb = curPlace.address_components[i].long_name
                    }
                    if (curPlace.address_components[i].types.includes('administrative_area_level_2')) {
                        this.address.town = curPlace.address_components[i].long_name
                    }
                    if (curPlace.address_components[i].types.includes('administrative_area_level_1')) {
                        this.address.province = curPlace.address_components[i].long_name
                    }
                    if (curPlace.address_components[i].types.includes('country')) {
                        this.address.country = curPlace.address_components[i].long_name
                    }
                    if (curPlace.address_components[i].types.includes('postal_code')) {
                        this.address.postalCode = curPlace.address_components[i].short_name
                    }
                }
                if (split && !this.address.streetNumber) {
                    try {
                        split[0] = parseInt(split[0])
                        if (split[0]) {
                            this.address.streetNumber = split[0].toString()

                        }

                    } catch (e) {

                    }
                }
                this.center = curPlace.geometry.location;
                this.address.lat = this.center.lat()
                this.address.lng = this.center.lng()

                this.locationMarker = this.center;
                if (this.$vuetify.breakpoint.xs) {
                    this.showAddressDialog = true
                    this.editingAddress = true

                } else {
                    this.showAddressForm = true
                    this.editingAddress = true
                }
                const point = {
                    type: "Point",
                    coordinates: [curPlace.geometry.location.lng(), curPlace.geometry.location.lat()],
                };
                let testPoly = this.glookup.getContainers(point);
                if (testPoly.features.length > 0) {
                    this.polyInfo = testPoly.features[0]
                    this.selectedNetwork = this.polyInfo.properties.network.id
                }
            })
        },
        plotMap() {
            if (this.$refs.mapRef) {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    // this.initMapAutocompletePlot();
                    // this.initMapAutocompleteOutsideNetworks();
                    this.map = map;
                    this.mapLoaded = true;
                    this.map.data.addGeoJson(this.geoData);
                    this.map.data.setStyle((feature) => {
                        let color = "orange";
                        let keys = Object.keys(feature)
                        let find = keys.find(x=>{
                            return typeof feature[x] == 'object' && feature[x].network
                        })
                        if ((feature[find] && feature[find].network.networkStatus === "Live")) {
                            color = "#3dc431";
                        } else if ((feature[find] && feature[find].network.networkStatus === "In Progress")) {
                            color = "blue";
                        } else if ((feature[find] && feature[find].network.networkStatus === "Planned")) {
                            color = "orange";
                        }
                        return {
                            fillColor: color,
                            fillOpacity: 0.3,
                            strokeWeight: 2,
                            strokeColor: color,
                        };
                    });
                    this.initMapAutoComplete()
                    this.polyInfo = {};
                    this.locationInfo = {};
                    this.infoWinOpen = false;
                    this.locationMarker = {};
                    this.locationInfoWindowOpen = false;
                    this.map.data.addListener("click", (event) => {
                        this.polyInfo = {}
                        this.selectedNetwork = null
                        let keys = Object.keys(event.feature)
                        let feature = null
                        for (let i = 0; i < keys.length; i++) {
                            if (typeof event.feature[keys[i]] == 'object') {
                                if (event.feature[keys[i]].network) {
                                    feature = event.feature[keys[i]]
                                }
                            }
                        }
                        if (feature) {
                            this.polyInfo = {
                                type: "Network",
                                name: feature.name,
                                units: feature.units,
                                fno: feature.fno,
                                network: feature.network,
                            };
                            this.selectedNetwork = this.polyInfo.network.id
                        } else {
                            this.polyInfo = {}
                            this.selectedNetwork = null
                        }
                        this.getAddressData(event, this.polyInfo)
                        let testPoly = new google.maps.Polygon({
                            paths: event.feature
                                .getGeometry()
                                .getAt(0)
                                .getArray(),
                        });
                        if (google.maps.geometry.poly.containsLocation(event.latLng, testPoly)) {}
                    });

                });
                this.loading = false
            }
        },
        reset() {
            this.polyInfo = {};
            this.locationMarker = {};
            this.address = {}
            this.showAddressForm = false
            this.key++
        },
        setAddress() {
            if(this.matchedUnit){
this.address = {
                id: this.matchedUnit.id,
                fullUnitDetails: this.matchedUnit,
                friendlyAddress: this.matchedUnit.locationDescription,
                locationDescription: this.matchedUnit.locationDescription,
                unitNumber: this.matchedUnit.unitNo,
                floorNo: this.matchedUnit.floorNo,
                building: null,
                streetNumber: this.matchedUnit.streetNumber,
                streetName: this.matchedUnit.complexStreetName,
                suburb: this.network.suburb,
                town: this.network.town,
                province: null,
                country: this.network.country,
                postalCode: this.network.postalCode,
            }
            } else {
                delete this.address.fullUnitDetails
                delete this.address.friendlyAddress
                delete this.address.locationDescription

            }
            
            this.addressKey ++
        },
        setLocation(location) {
            this.matchedUnit = location
            this.setAddress()
        }
    }
}
</script>

<style>
.mobileStep {
    font-size: 12px;
    width: 100%;
}
</style>
